export const getHelpTextId = (fieldId) => `${fieldId}_help-text`;
//# sourceMappingURL=get-help-text-id.js.map